import React from "react";
import { keyFormat } from "../../../features/ValueFormater";

function formatInfoValue(value) {
  if (value === 0) return "0";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

export default function InfoRows({ data = {}, className = "" }) {
  const entries = Object.entries(data || {});

  if (!entries.length) {
    return <div className="new-merchant-information__empty-copy">No information available.</div>;
  }

  return (
    <div
      className={[
        "new-merchant-information__kv-grid",
        className,
      ].filter(Boolean).join(" ")}
    >
      {entries.map(([key, value]) => (
        <div className="new-merchant-information__kv-row" key={key}>
          <div className="new-merchant-information__kv-label">{keyFormat(key).trim()}</div>
          <div className="new-merchant-information__kv-value">{formatInfoValue(value)}</div>
        </div>
      ))}
    </div>
  );
}
